<script lang=ts>
      import BlockWidth from "../blocks/BlockWidth.svelte"
      import Metatags from "../metatags/Metatags.svelte"
      import CatalogueList from "./CatalogueList.svelte"

  
  let { items } = $props()

</script>



<BlockWidth width="wide">
  <CatalogueList items={items}></CatalogueList>
</BlockWidth>

<style lang=postcss>
  
</style>
